import PageHero from "../components/PageHero";

export default function Contact() {
  return (
    <section>
      <PageHero title="Contact" subtitle="Hai să vorbim despre rochia ta." />
      <div className="grid md:grid-cols-2 gap-8">
        <form className="grid gap-3">
          <div>
            <label className="block text-sm mb-1">Nume</label>
            <input className="w-full border rounded-lg p-2" placeholder="Numele tău" />
          </div>
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input type="email" className="w-full border rounded-lg p-2" placeholder="email@exemplu.ro" />
          </div>
          <div>
            <label className="block text-sm mb-1">Mesaj</label>
            <textarea rows="5" className="w-full border rounded-lg p-2" placeholder="Spune-ne despre eveniment..." />
          </div>
          <button type="submit" className="rounded-xl bg-black text-white px-4 py-2">Trimite</button>
        </form>

        <div className="text-sm text-gray-700">
          <p><strong>Email:</strong> contact@tytystyle.ro</p>
          <p><strong>Telefon:</strong> 07xx xxx xxx</p>
          <p><strong>Program:</strong> Luni–Vineri, 10:00–18:00</p>
          <p className="mt-4">Programările se stabilesc în prealabil. Te rugăm să ne scrii câteva detalii despre eveniment, preferințe și termen.</p>
        </div>
      </div>
    </section>
  );
}
